import { createToaster } from '@skeletonlabs/skeleton-svelte';


export const userContainer: {
    selectedUpdateId: string | null,
    layoutOverride: boolean,
    showingCartPopup: boolean,
    hideCartOverriden: boolean,
    isAtCartPage: boolean
    prevPage: string | null,
    prevURL: URL | null,
    searchText: string,
    showingSearch: boolean,
    showingMobileFilters: boolean,
} = $state({
    user: null,
    selectedUpdateId: null,
    layoutOverride: false,
    showingCartPopup: false,
    hideCartOverriden: false,
    isAtCartPage: false,
    prevPage: null,
    prevURL: null,
    searchText: '',
    showingSearch: true,
    showingMobileFilters: false,
})

export const toaster = $state(createToaster())

/**
 * Global product mappings store for consistent URLs and titles across the app.
 * These are populated by pages that load from the server (e.g., /shoes page)
 * and can be used by components like search results, cart, etc.
 */
export const productMappings: {
    slugMapping: Record<string, string>;   // handle → slug
    titleMapping: Record<string, string>;  // handle → formattedTitle
} = $state({
    slugMapping: {},
    titleMapping: {}
});

/**
 * Update the global product mappings. Called by pages that receive mappings from the server.
 */
export function updateProductMappings(
    slugMapping: Record<string, string>,
    titleMapping: Record<string, string>
) {
    // Merge with existing mappings (don't replace, in case different pages load different products)
    productMappings.slugMapping = { ...productMappings.slugMapping, ...slugMapping };
    productMappings.titleMapping = { ...productMappings.titleMapping, ...titleMapping };
}

export interface EnhancedImageModule {
    [key: string]: any; // Allows flexibility
    // You *could* add known properties if needed:
    // src?: string;
    // width?: number;
    // height?: number;
    // sources?: { srcset: string; type: string }[];
}
export type EnhancedImageModules = Record<string, { default: EnhancedImageModule } | EnhancedImageModule>;
  
export const allEnhancedImages: EnhancedImageModule = $state(import.meta.glob('/src/lib/assets/imgs/**/*.{avif,gif,heif,jpeg,jpg,png,tiff,webp,svg}', {
    eager: true, // Load the modules immediately
    query: { enhanced: true } // <<< This is crucial for enhanced:img
}));

export function getImageModule(imagePath: string | undefined): EnhancedImageModule | undefined {
    if (!imagePath) {
      return undefined; // Handle items with no image path
    }
    const moduleOrObject = allEnhancedImages[imagePath];

    if (!moduleOrObject) {
        if (import.meta.env.DEV) {
            console.warn(`Enhanced image module not found for path: ${imagePath}. Check path and glob pattern.`);
        }
        return undefined;
    }

    // Handle potential nesting under 'default' common with eager imports
    // Check if moduleOrObject has a 'default' property that looks like our module
    // This check is basic; adjust if needed based on actual object structure
    if (typeof moduleOrObject === 'object' && moduleOrObject !== null && 'default' in moduleOrObject) {
        // Assuming the default export is the EnhancedImageModule
        return moduleOrObject.default as EnhancedImageModule;
    }

    // Otherwise, assume the object itself is the module
    return moduleOrObject as EnhancedImageModule;
  }



export function select(id: string | null) {
    userContainer.selectedUpdateId = id
}

export async function isUserSignedIn() {
    return false
    // try {
    //     userContainer.user = await account.get()
    //     return userContainer.user != null
    // }catch (e) {
    //     userContainer.user = null
    //     return false
    // }
    
}



export async function recreateStores() {
    // must be signed in!
    // try {
    //     account.get()
    // } catch (e) {
    //     return
    // }
    // console.log("was told to recreate stores..")
    // shoeStore.fetchNext()
    // cartStore.fetchAll([])
}
async function clearStores() {

}
async function initStores() {
    await recreateStores()
}


async function userSignedInTrigger() {
    console.log('initializing stores..')
    await initStores()
    
}
async function userSignedOutTrigger() {
    // userContainer.user = null;
    
    clearStores();
}
async function loginAsGuest() {
    // await account.createAnonymousSession()
    // userContainer.user = await account.get()
    // return
}
export async function appEntrypoint() {
    console.log("is user in?")
    if (await isUserSignedIn()) {
        console.log("yes")
        await userSignedInTrigger()
    } else {
        console.log("no, creating guest..")
        await loginAsGuest()
        await userSignedInTrigger()
    }
    
}

export async function logout() {
    // await account.deleteSession('current')
    await userSignedOutTrigger()
}